import * as React from "react";
export default class Accordian extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: this.props.toggle || false
        };
    }
    render() {
        let content = React.createElement("div", { className: this.state.toggle ? "accordian-content" : "accordian-content hidden" }, this.props.content);
        let icon = this.state.toggle ? "fa fa-minus" : "fa fa-plus";
        return (React.createElement("div", { className: "accordian" },
            React.createElement("div", { className: "accordian-header", onClick: () => { this.setState({ toggle: !this.state.toggle }); } },
                React.createElement("span", null, this.props.header),
                React.createElement("i", { className: icon })),
            content));
    }
}
;
//# sourceMappingURL=accordian.js.map